var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8002 1.6001C3.91654 1.6001 3.2002 2.31644 3.2002 3.2001V12.8001C3.2002 13.6838 3.91654 14.4001 4.8002 14.4001H11.2002C12.0839 14.4001 12.8002 13.6838 12.8002 12.8001V5.93147C12.8002 5.50712 12.6316 5.10016 12.3316 4.8001L9.6002 2.06873C9.30014 1.76867 8.89317 1.6001 8.46882 1.6001H4.8002ZM6.4002 9.6001C6.4002 9.15827 6.04202 8.8001 5.6002 8.8001C5.15837 8.8001 4.8002 9.15827 4.8002 9.6001V12.0001C4.8002 12.4419 5.15837 12.8001 5.6002 12.8001C6.04202 12.8001 6.4002 12.4419 6.4002 12.0001V9.6001ZM8.0002 7.2001C8.44202 7.2001 8.8002 7.55827 8.8002 8.0001V12.0001C8.8002 12.4419 8.44202 12.8001 8.0002 12.8001C7.55837 12.8001 7.2002 12.4419 7.2002 12.0001V8.0001C7.2002 7.55827 7.55837 7.2001 8.0002 7.2001ZM11.2002 6.4001C11.2002 5.95827 10.842 5.6001 10.4002 5.6001C9.95837 5.6001 9.6002 5.95827 9.6002 6.4001V12.0001C9.6002 12.4419 9.95837 12.8001 10.4002 12.8001C10.842 12.8001 11.2002 12.4419 11.2002 12.0001V6.4001Z",
    fill: "#507AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.2042cb01.svg";
export { ForwardRef as ReactComponent };